export const iconFontAwesomeAccessibilityCircleQuestion = (
	<i className="fa-solid fa-circle-question"></i>
);
